export default __webpack_public_path__ + "37e2b90735dce99b99532448ef5c4e86.png";